document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.elementor-widget-form form.elementor-form').forEach((element) => {


        element.querySelector("button[type='submit']").addEventListener('click', (event) => {
            element.classList.add('input-filling-intention')
        });

        // initialize change-value-intention
        element.querySelectorAll('input, select, textarea').forEach((element) => {
            element.addEventListener('blur', (event) => {
                event.target.classList.add('input-filling-intention')
            })
            element.addEventListener('change', (event) => {
                event.target.classList.add('input-filling-intention')
            })
        })
    })
})

jQuery(function($) {
    $( document ).on('submit_success', function(e, data) {
    document.querySelectorAll('.input-filling-intention').forEach((element) => {
        element.classList.remove('input-filling-intention');
    })
});
});
